import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ClientDetails from "./ClientDetails";
import { BACKUP_SETTINGS_SUMMARY } from "App/componentsConfig";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS, CONTENT } from "consts";
import Footer from "./Footer";
import { toggleSourceType, updateBackupSettingsStart } from "store/actions";
import { ReactComponent as SliderEditIcon } from "assets/images/app_svg/slider_edit.svg";
import {
  forbidExtraProps,
  arrayToString,
  convertSecsToWords,
  objectToArray,
  sortArray,
  formatTime12hr
} from "utils";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";

function SettingsSummary(props) {
  // const { lState } = useContext(LayoutContext);
  // const enablePC = lState.slidingPopup.alertName === "enablePC";
  const {
    clientDetails,
    encryption,
    scheduleInfo,
    emailNotification,
    volumes,
    cleanup
  } = props.backupSettings;
  const client = props.clients[props.backupSettings.clientDetails.clientUUID];
  const statusKey =
    props.enums.BackupScheduleStatus.props[client.status.value].key;
  const [editComputerName, setEditComputerName] = useState({
    editing: false,
    name: clientDetails.name,
    changed: false
  });

  function brief(key) {
    switch (key) {
      case "computerName":
        return (
          <React.Fragment>
            <input
              type="text"
              name=""
              value={editComputerName.name}
              onChange={e => inputComputerNameHandler(e.target.value)}
              disabled={!editComputerName.editing}
              maxLength="50"
            />
            <button
              className={[
                "btn_primary",
                editComputerName.changed ? "" : "btn_disable"
              ].join(" ")}
              onClick={updateSettings}
            >
              Save
            </button>
          </React.Fragment>
        );
      case "encryption":
        return CONTENT.backupSettings.encryption[
          props.enums.EncryptionType.props[encryption.type].key
        ].title;
      case "source":
        const volumesLabel = [];

        if (volumes.sourceType.current === "customize") {
          let entirePC = true;
          for (let key in volumes.list) {
            const drive = volumes.list[key];
            for (let volKey in drive.volume) {
              if (drive.volume[volKey].checked)
                volumesLabel.push(drive.volume[volKey].label + ":");
              if (entirePC && !drive.volume[volKey].checked) entirePC = false;
            }
          }
          if (entirePC) props.toggleSourceType("entire-pc");
        }

        return (
          CONTENT.backupSettings.sourceType[volumes.sourceType.current] +
          (volumesLabel.length > 0
            ? " (" + arrayToString(sortArray(volumesLabel)) + ")"
            : "")
        );
      case "schedule":
        return displayBackupSchedule(scheduleInfo, props.enums);
      case "advanceSettings":
        return "Cleanup after " + cleanup.scheduleCount + " incremental backup";
      case "email":
        if (emailNotification.emails.list.length === 0) {
          return "No emails added";
        }
        return emailNotification.emails.list.length > 0
          ? emailNotification.emails.list.length > 1
            ? emailNotification.emails.list[0] +
              " and " +
              (emailNotification.emails.list.length - 1) +
              (" other" +
                (emailNotification.emails.list.length > 2
                  ? "s Email IDs"
                  : " Email ID"))
            : emailNotification.emails.list[0]
          : "";
      default:
        break;
    }
  }

  function updateSettings() {
    if (editComputerName.changed) {
      const settings = {
        backupType: props.backupSettings.backupType,
        clientDetails: props.backupSettings.clientDetails,
        log: JSON.stringify({
          mode: "computerName",
          params: { name: editComputerName.name }
        })
      };
      settings.clientDetails.name = editComputerName.name;
      props.updateBackupSettingsStart(
        settings,
        props.backupSettings.clientDetails.clientUUID
      );
      toggleEditComputerName();
    }
  }

  function inputComputerNameHandler(changedName) {
    let temp = { ...editComputerName };
    temp.name = changedName;
    if (temp.name && temp.name !== clientDetails.name && temp.name !== "") {
      temp.changed = true;
    } else {
      temp.changed = false;
    }
    setEditComputerName(temp);
  }

  function toggleEditComputerName() {
    let temp = { ...editComputerName };
    temp.editing = !temp.editing;
    temp.name = clientDetails.name;
    setEditComputerName(temp);
  }

  function displayBackupSchedule(scheduleInfo) {
    let timeObj12hr = formatTime12hr(scheduleInfo.startTime.value);
    let time12hr =
      timeObj12hr.hrs + ":" + timeObj12hr.min + " " + timeObj12hr.meridian;

    switch (props.enums.ScheduleType.props[scheduleInfo.type.current].key) {
      case "INTERVAL":
        return "Every " + convertSecsToWords(scheduleInfo.interval.selected);
      case "DAILY":
        return "Everyday at " + time12hr;
      case "CUSTOM":
        const weekDays = [];
        objectToArray(props.enums.WeekDays.props, { 1: "priority" }).forEach(
          val => {
            if (scheduleInfo.weekDays.includes(val.code)) {
              weekDays.push(props.enums.WeekDays.props[val.code]);
            }
          }
        );
        return "Every " + arrayToString(weekDays, "name") + " at " + time12hr;
      case "NO_SCHEDULE":
        return "Never";
      case "MONTHLY":
        return "Every selected month and day at " + time12hr;
      // return (
      //   "Every " +
      //   formatMonths(scheduleInfo.months, props.enums.Months) +
      //   " on " +
      //   formatDates(scheduleInfo.monthDays) +
      //   " at " +
      //   time12hr
      // );
      default:
        break;
    }
  }

  return (
    <div className="slider_summary">
      <div className="slider_content_body">
        <ClientDetails
          clientDetails={props.backupSettings.clientDetails}
          backupSettings={props.backupSettings}
          client={client}
          statusKey={statusKey}
          updateBackupSettingsStart={props.updateBackupSettingsStart}
        />
        <div className="summary_setting_wrap">
          {/* !enablePC && val.key !== "encryption") || enablePC */}
          {BACKUP_SETTINGS_SUMMARY.map((val, i) => (
            <div
              key={i}
              className={[
                val.key === "computerName"
                  ? "summary_setting__item summary_setting__item_name"
                  : "summary_setting__item summary_setting__item_" + (i + 1),
                val.key === "encryption" ? "active" : "",
                val.key === "computerName" && editComputerName.editing
                  ? "edit_enabled"
                  : ""
              ].join(" ")}
              data-settings="summary_advance_settings"
              onClick={() =>
                val.key === "computerName" && !editComputerName.editing
                  ? toggleEditComputerName()
                  : val.key !== "encryption" && val.key !== "computerName"
                  ? props.switchPanel("edit", val.key)
                  : {}
              }
            >
              <div className="summary_setting__title">{val.title}:</div>
              <div className="summary_setting__select">{brief(val.key)}</div>

              {val.key !== "encryption" && (
                <div className="summary_setting__icon">
                  {val.key !== "computerName" ||
                  (val.key === "computerName" && !editComputerName.editing) ? (
                    <Tooltip {...TOOLTIPS.backupSettings.edit}>
                      <span
                        className="icon"
                        onClick={() =>
                          val.key === "computerName"
                            ? toggleEditComputerName()
                            : {}
                        }
                      >
                        <SliderEditIcon />
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip {...TOOLTIPS.slidingPopup.computerNameClose}>
                      <span className="icon close_edit_icon">
                        <span className="svg_close_slider_icon">
                          <CloseIcon
                            onClick={() =>
                              val.key === "computerName"
                                ? toggleEditComputerName()
                                : {}
                            }
                          />
                        </span>
                      </span>
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footer {...{ statusKey, client }} />
    </div>
  );
}

SettingsSummary.propTypes = forbidExtraProps(
  {
    backupSettings: PropTypes.shape({
      clientDetails: PropTypes.object.isRequired
    })
  },
  [
    "switchPanel",
    "currentPanel",
    "clients",
    "enums",
    "dispatch",
    "toggleSourceType",
    "updateBackupSettingsStart"
  ]
);

function mapStateToProps(state) {
  return {
    backupSettings: state.backupSettings,
    clients: state.dashboard.clients.list,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSourceType,
      updateBackupSettingsStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsSummary);
